import { useUser } from "@hooks";
import LayoutSettings from "@layouts/settings";
import { Outlet } from "react-router-dom";

const SettingsPage = () => {
  const user = useUser();
  return user.can("settings.index") ? (
    <LayoutSettings>
      <Outlet />
    </LayoutSettings>
  ) : (
    <></>
  );
};

export default SettingsPage;
